import { useRef, useState } from "react";
import { IconCopy } from "../icons/icons";
import styles from "./CopyField.module.css";

export function CopyField({ value, label }: { value: string; label: string }) {
  const [status, setStatus] = useState<"idle" | "copied" | "failed">("idle");
  const inputRef = useRef<HTMLInputElement>(null);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(value);
      setStatus("copied");
    } catch {
      // Clipboard permission denied or unavailable: fall back to selecting
      // the text so the owner can copy it manually.
      inputRef.current?.select();
      setStatus("failed");
    }
    window.setTimeout(() => setStatus("idle"), 2500);
  }

  return (
    <div>
      <div className={styles.row}>
        <input ref={inputRef} className={styles.input} type="text" readOnly value={value} aria-label={label} />
        <button type="button" className={styles.button} onClick={handleCopy}>
          <IconCopy width={16} height={16} />
          Copy
        </button>
      </div>
      <p className={styles.status} role="status" aria-live="polite">
        {status === "copied" && "Copied to clipboard."}
        {status === "failed" && "Couldn't copy automatically — the link is selected, copy it manually."}
      </p>
    </div>
  );
}
